<template>
  <div>
    <div class="bg-white shadow sm:rounded-md">
      <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
        <table class="table min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.bank") }}
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
              >
                {{ $t("messages.approveTopup.accountName") }}
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center text-right"
              >
                {{ $t("messages.approveTopup.amount") }}
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
              >
                {{ $t("messages.approveTopup.requestedDate") }}
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
              ></th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="data in dataRows" :key="data.deposit_id" class="hover:bg-gray-50">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.bank }}
              </td>
              <td class="px-6 text-center py-4 whitespace-nowrap text-sm text-gray-500">
                <p class="hover:underline cursor-pointer" @click="$router.push(`/players/${data.request_code}`)">
                  {{ data.bank_name }} <br /><small>{{ data.bank_no }}</small>
                </p>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                {{ data.amount / 100 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                {{ getLocaleDate(data.requested_at) }}
              </td>
              <td class="text-left" v-if="store.state.user.permissions.includes('RTB.DEPOSIT')">
                <button
                  @click="showDialog({ data })"
                  v-if="store.state.user.permissions.includes('OPERATOR.READ.FINANCE_APPROVE_TOPUP')"
                  class="rounded text-white p-2 m-1 bg-green-500 capitalize"
                >
                  {{ $t("messages.approveTopup.manualdeposit") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <dialog-component :isOpen="isShowDialog" title="Confirm Approve Deposit">
      <div class="text-left p-3">
        <p><b>Username</b>: {{ toDepositData.bank }}</p>
        <p><b>Amount</b> {{ (toDepositData.amount / 100).toLocaleString() }}</p>
        <p><b>Requested By</b>: {{ toDepositData.requested_by }}</p>
        <p><b>Request Date</b>: {{ getLocaleDate(toDepositData.requested_at) }}</p>
        <!-- <div class="row">
          <input
            v-model="phoneNumber"
            type="text"
            placeholder="input user phone number"
            class="rounded my-3 w-full "
          />
        </div> -->
      </div>
      <div v-if="isCheckTOTP" class="flex flex-col justify-center mb-2 mt-4">
        <span>{{ $t("messages.logIn.inputTotp") }}</span>
        <span v-if="currentAttempts > 0" class="text-red-600"> ใส่ผิดไปแล้ว {{ currentAttempts }} ครั้ง </span>
        <input type="text" v-model="totp" class="rounded" maxlength="6" :placeholder="$t('messages.logIn.totpCode')" />
      </div>
      <div class="flex flex-row justify-center text-center text-white">
        <button @click="closeDialog" class="rounded bg-gray-500 p-2 m-1">Cancel</button>
        <div>
          <button
            v-if="!isCheckTOTP"
            class="rounded bg-blue-500 p-2 m-1"
            @click="
              Number(toDepositData.amount / 100) >= maxValueToNoRequireOtp
                ? (isCheckTOTP = true)
                : onApproveManualDeposit()
            "
          >
            <!-- {{ Number(toDepositData.amount / 100) > maxValueToNoRequireOtp }}
            {{ maxValueToNoRequireOtp }}
            {{ Number(toDepositData.amount / 100) }} -->
            <font-awesome-icon
              v-if="isLoading"
              class="text-gray-500"
              :icon="['fas', 'circle-notch']"
              transform="grow-6"
              spin
            />
            <p>Approve</p>
          </button>
          <button v-if="isCheckTOTP" class="rounded bg-blue-500 p-2 m-1" @click="onCheckTOTP">
            <font-awesome-icon
              v-if="isLoading"
              class="text-gray-500"
              :icon="['fas', 'circle-notch']"
              transform="grow-6"
              spin
            />
            <p>Approve</p>
          </button>
          <button class="rounded bg-red-500 p-2 m-1" @click="onRejectManualDeposit">
            <font-awesome-icon
              v-if="isLoading"
              class="text-gray-500"
              :icon="['fas', 'circle-notch']"
              transform="grow-6"
              spin
            />
            <p>Reject</p>
          </button>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import { inject, defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import jwt_decode from "jwt-decode";
import { useRouter } from "vue-router";

dayjs.extend(localizedFormat);

export default defineComponent({
  props: {
    start_date: String,
    end_date: String,
  },
  components: {
    DialogComponent,
  },

  setup(props) {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const dataRows = ref([]);
    const toDepositData = ref({});
    // const phoneNumber = ref();
    const isLoading = ref(false);
    const currentAttempts = ref(0);

    const totp = ref("");
    const isCheckTOTP = ref(false);
    const maxValueToNoRequireOtp = ref(0);

    const isShowDialog = ref(false);
    const limit = ref(30);
    const offset = ref(0);

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    const showDialog = ({ data }) => {
      totp.value = "";
      toDepositData.value = data;
      isCheckTOTP.value = false;
      isShowDialog.value = true;
    };

    const closeDialog = () => {
      totp.value = "";
      toDepositData.value = {};
      isCheckTOTP.value = false;
      isShowDialog.value = false;
    };

    const getDate = (props) => {
      let start_date = props.start_date
        ? dayjs(props.start_date).format("YYYY-MM-DD")
        : dayjs().startOf("month").format("YYYY-MM-DD");
      let end_date = props.end_date
        ? dayjs(props.end_date).format("YYYY-MM-DD")
        : dayjs().endOf("month").format("YYYY-MM-DD");
      return { start_date, end_date };
    };

    const refetch = async () => {
      try {
        const waitingForApprove = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/deposits/pending-manual-list/${
            store.state.selectedOperator.operatorId
          }?start_date=${getDate(props).start_date}&end_date=${getDate(props).end_date}&limit=${limit.value}&offset=${
            offset.value
          }`
        );

        dataRows.value = waitingForApprove.data.rows;
      } catch (error) {
        console.log(error);
      }
    };

    // const checkPhoneNumberFormat = () => {
    //   if (
    //     phoneNumber.value.startsWith("+66") &&
    //     phoneNumber.value.length === 12
    //   ) {
    //     return phoneNumber.value;
    //   } else if (
    //     phoneNumber.value.startsWith("0") &&
    //     phoneNumber.value.length === 10
    //   ) {
    //     const phone = phoneNumber.value
    //       ? phoneNumber.value.replace("0", "+66")
    //       : null;

    //     return phone;
    //   } else {
    //     alert("wrong input format");
    //     return;
    //   }
    // };

    const onRejectManualDeposit = async () => {
      isLoading.value = true;
      let decode = jwt_decode(store.state.user.token);
      const body = {
        deposit_id: toDepositData.value.id,
        operator_id: toDepositData.value.operator_id,
        admin_id: decode.userId,
      };

      try {
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/deposits/reject/manual`,
          body
        );
        isLoading.value = false;
        toDepositData.value = {};
        isShowDialog.value = false;
        refetch();
      } catch (error) {
        isLoading.value = false;
        toDepositData.value = {};
        isShowDialog.value = false;
        alert(error);
        refetch();
      }
    };

    const onApproveManualDeposit = async () => {
      isLoading.value = true;
      // console.log({ toDeposit: toDepositData.value });
      let decode = jwt_decode(store.state.user.token);
      const body = {
        deposit_id: toDepositData.value.id,
        // phone_number: checkPhoneNumberFormat(),
        bank_account: toDepositData.value.bank_no,
        operator_id: toDepositData.value.operator_id, //store.state.selectedOperator.operatorId
        admin_id: decode.userId, //store.state.user.username
      };
      try {
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/deposits/approve/manual`,
          body
        );
        isLoading.value = false;
        toDepositData.value = {};
        isShowDialog.value = false;
        // phoneNumber.value = "";
        refetch();
      } catch (error) {
        isLoading.value = false;
        // phoneNumber.value = "";
        toDepositData.value = {};
        isShowDialog.value = false;
        alert(error);
        refetch();
      }
    };

    const onCheckTOTP = async () => {
      isLoading.value = true;
      try {
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/auth/admin-totp-check`,
          {
            requestId: Date.now().toString(),
            requestTs: Date.now(),
            code: totp.value,
            userId: store.state.user.id,
            callerFunction: "Confirm Approve Deposit",
          },
          { headers: { "x-cm-forwarded-for": store.state.user.ip } }
        );
        onApproveManualDeposit();
      } catch (e) {
        console.log(e?.response?.data?.isBlackList);
        if (e?.response?.data?.isBlackList) {
          store.commit("removeUserInfo");
          store.commit("removeOperators");
          router.push({ name: "Login" });
        } else if (e?.response?.data?.attempts) {
          currentAttempts.value = e.response.data.attempts;
        }
        alert("รหัส Google Authenticator ไม่ถูกต้อง");
      }
      isLoading.value = false;
    };

    onMounted(async () => {
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/get-operator-profile-user",
          {
            id: store.state.user.id,
          },
          {
            headers: {
              "x-cm-forwarded-for": store.state.user.ip,
            },
          }
        )
        .then((operator) => {
          const currentOperatorConfig = operator.data.result.find(res => res.operatorId == store.state.selectedOperator.operatorId)
          maxValueToNoRequireOtp.value = currentOperatorConfig.approveTopupTotpAmount || 0
        })
        .catch((err) => {
          console.log(error)
        });
      // maxValueToNoRequireOtp.value = store.state.selectedOperator.approveTopupTotpAmount;
      refetch();
    });

    return {
      store,
      isShowDialog,
      onApproveManualDeposit,
      onRejectManualDeposit,
      dataRows,
      getLocaleDate,
      showDialog,
      toDepositData,
      closeDialog,
      isLoading,
      // phoneNumber,
      store,
      currentAttempts,
      totp,
      isCheckTOTP,
      onCheckTOTP,
      maxValueToNoRequireOtp,
    };
  },
});
</script>

<style></style>
